export const PLATFORMS = [
  { id: "facebook", label: "Facebook" },
  { id: "instagram", label: "Instagram" },
  { id: "linkedin", label: "LinkedIn" },
  { id: "x", label: "X / Twitter" },
  { id: "tiktok", label: "TikTok" },
];

export const STATUSES = ["draft", "scheduled", "published"];

export const blankPost = () => ({
  platforms: ["instagram", "facebook"],
  content: "",
  image_url: "",
  scheduled_at: "",
  hashtags: [],
  status: "draft",
});
